import React from 'react';
import '../../../v2-theme.css';

/**
 * V2Textarea Component
 *
 * Multiline text input with v2 design system styling
 *
 * @param {string} label - Textarea label text
 * @param {string} name - Textarea name attribute
 * @param {string} value - Textarea value
 * @param {function} onChange - Change handler
 * @param {string} placeholder - Placeholder text
 * @param {boolean} required - Whether textarea is required
 * @param {string} error - Error message to display
 * @param {boolean} disabled - Whether textarea is disabled
 * @param {number} rows - Number of visible rows
 */
const V2Textarea = ({
  label,
  name,
  value,
  onChange,
  placeholder = '',
  required = false,
  error = '',
  disabled = false,
  rows = 4,
  className = '',
  ...props
}) => {
  const textareaClasses = [
    'v2-textarea',
    error ? 'v2-textarea-error' : '',
    disabled ? 'v2-textarea-disabled' : '',
    className
  ].filter(Boolean).join(' ');

  return (
    <div className="v2-form-group">
      {label && (
        <label className="v2-label" htmlFor={name}>
          {label}
          {required && <span className="v2-required">*</span>}
        </label>
      )}
      <textarea
        id={name}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        rows={rows}
        className={textareaClasses}
        {...props}
      />
      {error && <div className="v2-error-message">{error}</div>}
    </div>
  );
};

export default V2Textarea;
